const initialState = false;

const reducer = (state = initialState, action) => {
  switch (action.type) {
  case "UPDATE_GRID":
    return action.payload;
  default:
    return state;
  }
};

export default reducer;
